export class CourseApplicationFilter {
    userId: number;
    partnerId: number; // partnerId and userId is mutually exclusive, only one of them should be provided in filter params
    studentName: string;
    studentEmail: string;
    instituteName: string;
    courseStartDate: string;     
	applicationStatusId: number;
}